import {
    IRelatorioHistorico,
    IRelatorioRegua,
    IRelatorioReguaBaseRequest,
    IRelatorioReguaRequest,
} from "../../../../Interfaces/Automacao/Regua/RelatorioDeEnvioRegua/RelatorioDeEnvioReguaInterfaces";
import {
    ListarRelatorioDeEnvioHistoricoService,
    ListarRelatorioDeEnvioPesquisaService,
    ListarRelatorioDeEnvioReguaService,
} from "../../../../Services/Automacao/Regua/RelatorioDeEnvioRegua/RelatorioDeEnvioReguaServices";
import { Controller } from "../../../Controller";

export const ListarRelatorioDeEnvioReguaController = (
    req: IRelatorioReguaRequest
) => Controller(ListarRelatorioDeEnvioReguaService<IRelatorioRegua>(req));

export const ExportarExcelRelatorioDeEnvioReguaController = (
    req: IRelatorioReguaRequest
) => Controller(ListarRelatorioDeEnvioReguaService<Blob>(req));

export const ListarRelatorioDeEnvioPesquisaController = (
    req: IRelatorioReguaBaseRequest
) => Controller(ListarRelatorioDeEnvioPesquisaService(req));

export const ListarRelatorioDeEnvioHistoricoController = (
    req: IRelatorioReguaBaseRequest,
    pagina: number
) =>
    Controller(
        ListarRelatorioDeEnvioHistoricoService<IRelatorioHistorico>(
            req,
            pagina,
            false
        )
    );

export const ExportExcelRelatorioDeEnvioHistoricoController = (
    req: IRelatorioReguaBaseRequest
) => Controller(ListarRelatorioDeEnvioHistoricoService<Blob>(req, 0, true));
